import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import NavBarWithSearch from "../utilities/NavBarWithSearch";
import Footer from "../utilities/Footer";
import "../../style.css";

const MainContentLayout = () => {
  return (
    <Fragment>
      <div className="main-content">
        <NavBarWithSearch hideSearch="True" />
        <div className="main-content-body">
          <Outlet />
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default MainContentLayout;
